/**
 * Mdm Logging Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * Contact: man-team-mdm@man.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RangeInstant } from './range-instant';
import { SystemLog } from './system-log';

export interface PersistedLogsRequest {
    id?: number;
    serialNumber: string;
    operationId: number;
    deviceType: PersistedLogsRequest.DeviceTypeEnum;
    requestedSystems: Array<PersistedLogsRequest.RequestedSystemsEnum>;
    status: PersistedLogsRequest.StatusEnum;
    requestedPeriod?: RangeInstant;
    logs?: Array<SystemLog>;
    createdDate: Date;
    requestedBy?: string;
}

export namespace PersistedLogsRequest {
    export type DeviceTypeEnum = 'CM4' | 'TBM3' | 'VCM';
    export const DeviceTypeEnum = {
        CM4: 'CM4' as DeviceTypeEnum,
        TBM3: 'TBM3' as DeviceTypeEnum,
        VCM: 'VCM' as DeviceTypeEnum
    };
    export type RequestedSystemsEnum = 'CHIPPS' | 'VUC' | 'NAD' | 'TELE' | 'TPA';
    export const RequestedSystemsEnum = {
        CHIPPS: 'CHIPPS' as RequestedSystemsEnum,
        VUC: 'VUC' as RequestedSystemsEnum,
        NAD: 'NAD' as RequestedSystemsEnum,
        TELE: 'TELE' as RequestedSystemsEnum,
        TPA: 'TPA' as RequestedSystemsEnum
    };
    export type StatusEnum = 'REQUESTED' | 'ERROR' | 'UPLOADED' | 'PROVIDED';
    export const StatusEnum = {
        REQUESTED: 'REQUESTED' as StatusEnum,
        ERROR: 'ERROR' as StatusEnum,
        UPLOADED: 'UPLOADED' as StatusEnum,
        PROVIDED: 'PROVIDED' as StatusEnum
    };
}
